import React from "react";
import type Widget from "@/model/widget";
import WidgetCard from "./widget-card";
import { NoDataAvailable } from "@/pages/components/empty";
import RelatedQuestions from "../chatbot-popup/chatbot-related-questions";
import { useDispatch } from "react-redux";
import { setIsOpen, setUserDefaultQuery } from "@/store/chatbot/chatbot-slice";

type ChatbotWidgetProps = {
  className?: string;
  widget: Widget;
};

const ChatbotWidget: React.FunctionComponent<ChatbotWidgetProps> = ({
  widget,
}) => {
  const dispatch = useDispatch();

  const onQuestionSelect = (question: string) => {
    dispatch(setUserDefaultQuery([question]));
    dispatch(setIsOpen(true));
  };

  const renderWidget = () => {
    if (Array.isArray(widget?.queries) && widget?.queries?.length > 0) {
      return (
        <RelatedQuestions
          questions={widget?.queries}
          onQuestionSelect={onQuestionSelect}
        />
      );
    } else {
      return (
        <NoDataAvailable message="Frequently asked questions not available" />
      );
    }
  };

  return (
    <WidgetCard title={widget?.widgetDisplayName}>{renderWidget()}</WidgetCard>
  );
};

export default ChatbotWidget;
